const initMaps = async () => {
  const mapElements = document.querySelectorAll( '.acf-map' );

  if (!mapElements.length) {
    return;
  }

  const {Map} = await google.maps.importLibrary( 'maps' );
  const {Marker} = await google.maps.importLibrary( "marker" );

  mapElements.forEach( mapElement => {
    const lat = parseFloat( mapElement.dataset.lat );
    const lng = parseFloat( mapElement.dataset.lng );
    const center = {lat, lng};
    const zoom = parseInt( mapElement.dataset.zoom, 10 );
    const disableUi = parseInt( mapElement.dataset.disableUi, 10 ) === 1;
    const markerElements = mapElement.querySelectorAll( '.marker' );

    const map = new Map( mapElement, {
      center: center,
      zoom: zoom,
      disableDefaultUI: disableUi,
    } );

    if (markerElements.length > 0) {
      markerElements.forEach( (markerEl) => {
        const markerLat = parseFloat( mapElement.dataset.lat );
        const markerLng = parseFloat( mapElement.dataset.lng );
        const markerPosition = {lat: markerLat, lng: markerLng};

        const marker = new Marker( {
          clickable: false,
          map: map,
          position: markerPosition,
          optimized: false,
          title: markerEl.dataset.title,
        } );
      } );
    }
  } );
}

const acfMaps = () => {
  initMaps();
};

export default acfMaps;
